import { em } from 'polished'
import styled, { css } from 'styled-components'

export const Label = styled.label`
  display: flex;
  align-items: center;
  height: ${em(25)};
  background: transparent;
  position: relative;
  box-sizing: content-box;
  cursor: ${p => (p.isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${p => (p.isDisabled ? 0.6 : 1)};
  flex-wrap: wrap;
  ${p =>
    p.isChecked &&
    css`
      border-color: ${p.theme.colors.primary};
    `}
  @media (max-width: 768px) {
    height: auto;
  }
`

export const Input = styled.input`
  display: none;
`

export const OuterCircle = styled.span`
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${p => p.isChecked ? p.theme.colors.black: p.theme.colors.white};
  border: 1.5px solid ${p => p.isChecked ? p.theme.colors.black: 'rgba(0, 0, 0, 0.1)'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  transition: background-color ${p => p.theme.animation.timeStandard} ease,
    border-color ${p => p.theme.animation.timeStandard} ease;

  ${Label}:hover & {
    border-color: ${p => (p.isChecked ? p.theme.colors.black : 'rgba(0, 0, 0, 0.4)')};
  }
`

export const InnerCircle = styled.span`
  width: 6.4px;
  height: 6.4px;
  border-radius: 50%;
  background-color: ${p => p.theme.colors.white};
  transition: background-color 0.2s;
`

export const Text = styled.span`
  font-size: 16px;
  line-height: 25px;
  color: ${p => p.theme.colors.black};
  user-select: none;
  margin-right: 20px;
  white-space: nowrap;
    @media (max-width: 768px) {
      margin-right: 0;
    }
`

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  gap: ${em(20)};
  flex-wrap: nowrap;
   @media (max-width: 768px) {
    transform: scale(0.83);
    gap: 10px;
    width: fit-content;
    margin-left: 20px;
     ${p =>
      p.isMultiIcon &&
      css`
        margin-top: 10px;
        margin-left: 10px;
      `}
           
  }
  @media (max-width: 371.98px) {
    ${p =>
      p.isDoubleIcon &&
      css`
        margin-top: 10px;
        margin-left: 20px;
    `}
  }
  @media (max-width: 350px) {
    flex-wrap: wrap;
  }
`
